const DEVICE_KEY = 'demandjet.device';

/** Stable id for this browser, so a later sign-in on a new device can be emailed. */
export function browserDeviceId() {
  try {
    const existing = localStorage.getItem(DEVICE_KEY);
    if (existing) return existing;
    const id = crypto.randomUUID();
    localStorage.setItem(DEVICE_KEY, id);
    return id;
  } catch {
    return '';
  }
}
